<template>
  <a-drawer width="55vw" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="shopId">
        <span slot="label">
          <a-tooltip>
            {{ $t('店铺id') }}<template slot="title">{{ $t('店铺id') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.shopId" :disabled="true" :placeholder="$t('通用.输入.请输入') + $t('店铺id')" />
      </a-form-model-item>
      <a-form-model-item prop="bankUserPhone">
        <span slot="label">
          <a-tooltip>
            {{ $t('银行预留手机号') }}<template slot="title">{{ $t('银行预留手机号') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.bankUserPhone"
          :maxLength="100"
          :disabled="true"
          :placeholder="$t('通用.输入.请输入') + $t('银行预留手机号')"
        />
      </a-form-model-item>
      <a-form-model-item prop="bankAccountName">
        <span slot="label">
          <a-tooltip>
            {{ $t('银行开户名') }}<template slot="title">{{ $t('银行开户名') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.bankAccountName"
          :maxLength="50"
          :disabled="true"
          :placeholder="$t('通用.输入.请输入') + $t('银行开户名')"
        />
      </a-form-model-item>
      <a-form-model-item prop="bankName">
        <span slot="label">
          <a-tooltip>
            {{ $t('开户银行支行名称') }}<template slot="title">{{ $t('开户银行支行名称') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.bankName"
          :maxLength="50"
          :disabled="true"
          :placeholder="$t('通用.输入.请输入') + $t('开户银行支行名称')"
        />
      </a-form-model-item>
      <a-form-model-item prop="bankAddress">
        <span slot="label">
          <a-tooltip>
            {{ $t('开户银行所在地') }}<template slot="title">{{ $t('开户银行所在地') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.bankAddress"
          :maxLength="50"
          :disabled="true"
          :placeholder="$t('通用.输入.请输入') + $t('开户银行所在地')"
        />
      </a-form-model-item>
      <a-form-model-item prop="accountInstCity">
        <span slot="label">
          <a-tooltip>
            {{ $t('开户行城市') }}<template slot="title">{{ $t('开户行城市') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.accountInstCity"
          :maxLength="100"
          :disabled="true"
          :placeholder="$t('通用.输入.请输入') + $t('开户行城市')"
        />
      </a-form-model-item>
      <a-form-model-item prop="accountInstProvince">
        <span slot="label">
          <a-tooltip>
            {{ $t('开户行省份') }}<template slot="title">{{ $t('开户行省份') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.accountInstProvince"
          :maxLength="100"
          :disabled="true"
          :placeholder="$t('通用.输入.请输入') + $t('开户行省份')"
        />
      </a-form-model-item>
      <a-form-model-item prop="bankAccountNumber">
        <span slot="label">
          <a-tooltip>
            {{ $t('公司银行账号') }}<template slot="title">{{ $t('公司银行账号') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.bankAccountNumber"
          :maxLength="50"
          :disabled="true"
          :placeholder="$t('通用.输入.请输入') + $t('公司银行账号')"
        />
      </a-form-model-item>
      <a-form-model-item prop="moneyBzj">
        <span slot="label">
          <a-tooltip>
            {{ $t('保证金') }}<template slot="title">{{ $t('保证金') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.moneyBzj" :disabled="true" :placeholder="$t('通用.输入.请输入') + $t('保证金')" />
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label">
          <a-tooltip>
            {{ $t('备注') }}<template slot="title">{{ $t('备注') }}</template>
          </a-tooltip>
        </span>
        <a-input
          :disabled="true"
          v-model="form.remark"
          :placeholder="$t('通用.输入.请输入')"
          type="textarea"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item prop="shopProtocol">
        <span slot="label">
          <a-tooltip>
            {{ $t('打款截图') }}<template slot="title">{{ $t('打款截图') }}</template>
          </a-tooltip>
        </span>
        <!-- <a-input v-model="form.shopProtocol" :maxLength="255" :placeholder="$t('通用.输入.请输入') + $t('打款截图')" /> -->
        <OssUploadSingle
          v-model="form.shopProtocol"
          :showUploadList="{ showRemoveIcon: false, showPreviewIcon: true }"
          type="img"
          :prefix="shop"
          :maxSize="200"
        ></OssUploadSingle>
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>
            {{ $t('状态') }}<template slot="title">{{ $t('状态') }}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button :value="1"> 通过 </a-radio-button>
          <a-radio-button :value="2"> 拒绝 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="reason">
        <span slot="label">
          <a-tooltip>
            {{ $t('失败原因') }}<template slot="title">{{ $t('失败原因') }}</template>
          </a-tooltip>
        </span>
        <a-input
          type="textarea"
          v-model="form.reason"
          :required="form.status === 2 ? true : false"
          :maxLength="300"
          :placeholder="$t('通用.输入.请输入') + $t('失败原因')"
        />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"
        ></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRenewRecord, addRenewRecord, updateRenewRecord } from '@/api/shop/renewRecord'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import OssUploadSingle from '@/components/OssUploadSingle'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
    OssUploadSingle,
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        shopId: null,

        bankUserPhone: null,

        bankAccountName: null,

        bankName: null,

        bankAddress: null,

        accountInstCity: null,

        accountInstProvince: null,

        bankAccountNumber: null,

        moneyBzj: null,

        remark: null,

        shopProtocol: null,

        status: 0,

        reason: null,

        createTime: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        shopId: null,
        bankUserPhone: null,
        bankAccountName: null,
        bankName: null,
        bankAddress: null,
        accountInstCity: null,
        accountInstProvince: null,
        bankAccountNumber: null,
        moneyBzj: null,
        remark: null,
        shopProtocol: null,
        status: 0,
        reason: null,
        createTime: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRenewRecord({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('审核')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateRenewRecord(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            message = this.$t('通用.文本.修改成功')
            addRenewRecord(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
